/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect} from 'react'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import OutOfStockOccurrenceDetailsTable from '../../sections/table/OutOfStockOccurrenceDetailsTable'
import useOutOfStockOccurenceOperations from '../../hooks/useOutOfStockOccurenceOperations'

interface OutOfStockOccurrenceDetailsModalProps {
  onClose: () => void
  row: any
  isParentRow: boolean
}

const OutOfStockOccurrenceDetailsModal = ({
  onClose,
  row,
  isParentRow,
}: OutOfStockOccurrenceDetailsModalProps) => {
  const {productVariants, isOperationLoading, getOutOfStockOccurenceDetails} =
    useOutOfStockOccurenceOperations()

  useEffect(() => {
    getOutOfStockOccurenceDetails(row?.parentSku, row?.variantSku)
  }, [row?.parentSku, row?.variantSku])

  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      title={row?.isParent ? row?.productTitle : row?.variantSku}
      disableFooter={true}
      dialogClassName='mw-1000px'
      body={
        <OutOfStockOccurrenceDetailsTable
          isParentRow={isParentRow}
          productVariants={productVariants}
          isOperationLoading={isOperationLoading}
        />
      }
    />
  )
}

export default OutOfStockOccurrenceDetailsModal
